export const HtmlDomEvent = {
  Input: 'input',
  Blur: 'blur'
};
